var map = {
	"./007.png": 2869,
	"./0E0736BE-0840-4020-9FED-4ABBB4D86591.jpg": 6760,
	"./Davinci.gif": 9097,
	"./F_7186.jpg": 8447,
	"./F_7244.jpg": 7262,
	"./F_7249.jpg": 2431,
	"./banner.png": 3250,
	"./blackboard.png": 4571,
	"./bride.png": 242,
	"./bridegroom.png": 766,
	"./frame.png": 6637,
	"./information.jpg": 2756,
	"./museum.gif": 7311,
	"./museum.jpg": 2116,
	"./museum.png": 4336,
	"./wall.jpg": 1380,
	"./wall.webp": 1293,
	"./wall_new.png": 2263,
	"./wall_old.jpg": 3370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;